import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { YES } from "const"
import {
    StoreType,
    CcRequirementObjectProps,
    addModal,
    moduleIds,
} from "client/store"
import {
    FormGroup,
    Label,
    LabelButton,
    Empty,
    UserIcon,
    Delimiter,
    ListWrapper,
    ListItem,
    ListItemTitle,
} from "client/components"

import ManageLifecyclePhases from "./lifecyclePhases"
import { RequirementStateContent } from "./styled"

const State = ({
    requirement,
    editAccess,
}: CcRequirementObjectProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const projectModules = JSON.parse(project.modules)
    const lifecycleModuleAccess = packageSettings.lifecycleModuleAccess === YES && projectModules[moduleIds.lifecycle]

    const { phaseLinks } = requirement

    return (
        <RequirementStateContent>
            <FormGroup>
                <Label>{lang.createdBy}</Label>
                <UserIcon user={userList[requirement.creator]} size="sm" />
            </FormGroup>
            {
                lifecycleModuleAccess
                && <Delimiter size="sm" />
            }
            {
                lifecycleModuleAccess && (
                    <FormGroup>
                        <Label>
                            {lang.lifecyclePhases}
                            {
                                editAccess && (
                                    <LabelButton
                                        onClick={() => dispatch(addModal({
                                            key: "editPhases",
                                            content: <ManageLifecyclePhases requirementId={requirement.id} />,
                                        }))}
                                    >
                                        {lang.manage}
                                    </LabelButton>
                                )
                            }
                        </Label>

                        <ListWrapper>
                            {
                                phaseLinks.map((phaseLink) => {
                                    const phasetitle = `${phaseLink.phase.lifecycle.name} > ${phaseLink.phase.name}`
                                    return (
                                        <ListItem key={phaseLink.phaseId}>
                                            <ListItemTitle title={phasetitle}>{phasetitle}</ListItemTitle>
                                        </ListItem>
                                    )
                                })
                            }
                            {
                                phaseLinks.length === 0
                                && <Empty />
                            }
                        </ListWrapper>
                    </FormGroup>
                )
            }
        </RequirementStateContent>
    )
}
export default State
